module.exports = __webpack_public_path__ + "static/media/attn.com_stories_11891_officer-tim-mcmillan-posts-about-pulling-over-black-man_plot.1ca54b04.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/attn.com_stories_11891_officer-tim-mcmillan-posts-about-pulling-over-black-man_plot.png
// module id = 341
// module chunks = 0